<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <b-row>
            <b-col sm="12">
              <b-row>
                <b-col sm="4">
                  <span class="pr-"><strong>총 {{excelTotalCnt}}건</strong></span>
                  <b-button size="sm" variant="success" v-on:click="excelInfoDownloadForm()" class="exceldown_button"><h5 style="margin-bottom:0px"><i class="fa fa-file-excel-o"></i> 엑셀다운로드</h5></b-button>
                  <span style="color:#8c8872; font-weight:bold; font-size:15px">* 아래 정보를 다운받으실수 있습니다.</span>
                </b-col>
              </b-row>
            </b-col>


            <b-col v-if="isLoading" sm="12">
              <div class="text-center loadingbar" style="margin:300px 0 350px 0">
                <div style="width:200px; margin:0 auto; vertical-align:middle">
                  <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                  <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                </div>
              </div>
            </b-col>

            <b-col v-else sm="12" class="pt-sm-1 tabledisplay">
              <b-row v-show="active_view_type=='VIEW'" class="tabledisplay">
                <b-col sm="1" style="margin-bottom:5px"><span class="badge" style="background-color:#636965; color:#fff; border:2px solid #1f2229; font-size:15px">GUEST 리스트</span></b-col>
                <b-col sm="12">
                  <b-table
                    ref="totaltable"
                    striped
                    hover
                    :fields="fieldItems"
                    :items="guestitems"
                    :busy="guestitems == 0">
                    <div slot="table-busy" class="text-center my-2">
                      <strong>데이터가 없습니다.</strong>
                    </div>

                  </b-table>
                </b-col>
              </b-row>

              <b-row class="tabledisplay">
                <b-col sm="1" style="margin-bottom:5px"><span class="badge" style="background-color:#636965; color:#fff; border:2px solid #1f2229; font-size:15px">탈퇴 리스트</span></b-col>
                <b-col sm="12">
                  <b-table
                    ref="totaltable"
                    striped
                    hover
                    :fields="fieldItems"
                    :items="withdrawitems"
                    :busy="withdrawitems == 0">
                    <div slot="table-busy" class="text-center my-2">
                      <strong>데이터가 없습니다.</strong>
                    </div>

                    <template slot="authority_name" slot-scope="data">
                      <template v-if="data.item.user_id=='WITHDRAW'">
                        -
                      </template>
                      <template v-else>
                        {{data.item.authority_name}}
                      </template>
                    </template>

                  </b-table>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="1" style="margin-bottom:5px">
                  <span class="badge" style="background-color:#077abd; border:2px solid #033958; color:#fff; font-size:15px">USER 리스트</span>
                </b-col>
                <b-col sm="10"></b-col>
                <b-col sm="1" class="d-flex justify-content-end my-1">
                  <b-form-select v-model="perPage" :options="pageOptions"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-table
                    ref="totaltable"
                    striped
                    hover
                    :fields="fieldItems"
                    :items="useritems"
                    :busy="useritems == 0"
                    :current-page="currentPage"
                    :per-page="perPage">
                    <div slot="table-busy" class="text-center my-2">
                      <strong>데이터가 없습니다.</strong>
                    </div>
                    <template slot="user_id" slot-scope="data">
                      <div><a href="javascript:void(0)" v-on:click="openStatUserInfoModal(data.item)">{{data.item.user_id}}</a></div>
                    </template>

                    <template slot="mobile" slot-scope="data">
                      {{ formatPhoneNumber(data.item.mobile) }}
                    </template>

                  </b-table>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="12" class="pt-sm-1">
              <b-row class="pb-sm-2">
                <b-col sm="12" class="my-1">
                  <b-pagination v-model="currentPage" :total-rows="useritems.length" :per-page="perPage" align="center"/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="유저 정보" size="xl" v-model="contentStatUserFormModal" @ok="contentStatUserFormModal = false" no-close-on-backdrop no-close-on-esc hide-footer>
      <contentStatUserInfoModal v-bind:contentStatUserInfoOptions="contentStatUserInfoOptions" v-bind:contentStatUserFormModal="contentStatUserFormModal" ref="contentStatUserInfoModalRef"></contentStatUserInfoModal>
      <hr />
      <span class="float-right" style="padding-right:20px;">
          <b-button variant="outline-danger" @click="contentStatUserFormModal = false">닫기</b-button>
        </span>
    </b-modal>
  </div>
</template>
<script>


import contentStatUserInfoModal from '../../ContentStatUserInfoModal';
import { EventBus } from "../../../../event-bus";
import swal from "sweetalert2";
const moment = require("moment");

export default {
  name: 'DrInfoList',
  props: {
    queryParams: {
      type: Object
    },
    fieldItems: {
      type: Array
    },
    fullDate: {
      type: Array
    },
  },
  components: {
    contentStatUserInfoModal
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindDrUserList", () => {
      this.getContentStatisticsInfoUserList();
    });
  },
  data () {
    return {
      isLoading: true,

      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      items: [],

      contentStatUserInfoOptions: {
        user_id: '',
        dr_code: '',
        view_type: '',
        start_date: '',
        end_date: '',
      },

      active_view_type:'VIEW', //검색 버튼을 눌렀을 때 활성화된 VIEW_TYPE
      active_start_date: '',
      active_end_date: '',


      contentStatUserFormModal:false,

      excelTotalCnt: 0,

      guestitems: [],
      withdrawitems: [],
      useritems: [],
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.getContentStatisticsInfoUserList();
    });
  },
  methods: {

    getContentStatisticsInfoUserList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.isLoading = true;
      self.queryParams.start_date = this.$parent.getFormatDate(this.fullDate[0]);
      self.queryParams.end_date = this.$parent.getFormatDate(this.fullDate[1]);

      this.$parent.chagefield(this.queryParams.view_type);

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);
      self.$http.post('/api/select/contentStatisticsInfoUserList?access_token=' + token, data, null)
        .then((result) => {

          console.log('search result : ', result.data);

          self.isLoading = false;
          self.active_view_type = self.queryParams.view_type;
          self.active_start_date = self.queryParams.start_date;
          self.active_end_date = self.queryParams.end_date;


          self.useritems = result.data.userInfoList;
          self.useritems.forEach((el, idx) => el.rnum = self.useritems.length - idx);

          self.guestitems = result.data.guestInfoList;
          self.guestitems.forEach((el, idx) => el.rnum = self.guestitems.length - idx);

          self.withdrawitems = result.data.withdrawInfoList;
          self.withdrawitems.forEach((el, idx) => el.rnum = self.withdrawitems.length - idx);

          self.excelTotalCnt = self.useritems.length + self.guestitems.length + self.withdrawitems.length;
        })
    },

    openStatUserInfoModal(data) {
      var self = this;
      self.contentStatUserInfoOptions.user_id = data.user_id;
      self.contentStatUserInfoOptions.dr_code = self.queryParams.dr_code;
      self.contentStatUserInfoOptions.view_type = self.queryParams.view_type;
      self.contentStatUserInfoOptions.start_date = self.queryParams.start_date;
      self.contentStatUserInfoOptions.end_date = self.queryParams.end_date;
      self.contentStatUserFormModal = true;
    },


    excelInfoDownloadForm(){
      var self = this;
      var authKeyTable = "";
      authKeyTable += '<section class="container_login loginbox" style="margin:0px auto">';
      authKeyTable += '    <dl style="margin-top:32px">';
      authKeyTable += '        <dd>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:17px">현재 아래의 기준으로 다운로드 됩니다.</p>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:20px; color:#ff6863">';
      authKeyTable += '             현재 데이터수 : <span style="color:#ea0000; font-weight:bold">'+Number(self.excelTotalCnt).toLocaleString()+'</span>';
      authKeyTable += '            </p>';
      authKeyTable += '        </dd>';
      authKeyTable += '    </dl>';
      authKeyTable += '    <section class="container_join" style="margin:0px; padding:0px">';
      authKeyTable += '       <h2 style="border-top:4px solid #222; padding-top:20px"></h2>';
      authKeyTable += '       <dl style="padding:0px 10px">';
      var viewcodename = '';
      if(self.active_view_type == 'VIEW'){
        viewcodename = '조회';
      }else if(self.active_view_type == 'DOWNLOAD'){
        viewcodename = '다운로드';
      }else if(self.active_view_type == 'RECOMMAND'){
        viewcodename = '추천';
      }else if(self.active_view_type == 'RESEARCH'){
        viewcodename = '후속연구요청수';
      }

      authKeyTable += '         <dt style="width:35%; font-size:20px">조회 구분</dt>';
      authKeyTable += '         <dd style="width:65%; font-size:17px">'+viewcodename+'</dd>';
      authKeyTable += '         <dt style="width:35%; font-size:20px">검색된 기간</dt>';
      authKeyTable += '         <dd style="width:65%; font-size:17px">'+(self.active_start_date ? self.active_start_date+' ~ '+self.active_end_date : '전체')+'</dd>';
      authKeyTable += '       </dl>';
      authKeyTable += '    </section>';
      authKeyTable += '</section>';

      swal.fire({
        title: '엑셀다운로드!',
        html: authKeyTable,
        type: 'warning',
        showConfirmButton: true,
        confirmButtonColor: '#ff500f',
        confirmButtonText: 'DOWNLOAD',
        onBeforeOpen: () => {
          const content = swal.getContent()
          const $ = content.querySelector.bind(content)

        },
      }).then((swalResult) => {
        if (swalResult.value) {
          // console.log(self.userkeyParams);
          var resultTable = "";
          resultTable += '<table class="r-point" cellspacing="0" style="margin-top: 15px">';
          resultTable += '  <tr>';
          resultTable += '    <th width="120">총 데이터수</th>';
          resultTable += '    <td>'+Number(self.excelTotalCnt).toLocaleString()+'</td>';
          resultTable += '  </tr>';
          resultTable += '  <tr>';
          resultTable += '    <th>파일 형식</th>';
          resultTable += '    <td>.xlsx</td>';
          resultTable += '  </tr>';
          resultTable += '</table>';

          swal.fire({
            // type: 'success',
            title: '다운로드 중 ..',
            html: resultTable,
            showConfirmButton: false,
            allowOutsideClick: false,
            // timer: 2000,
            onOpen: function (){
              swal.showLoading();

              var filenames = '콘텐츠통계_상세('+self.queryParams.report_name+')';
              if(self.active_view_type == 'VIEW'){
                filenames += '_조회';
              }else if(self.active_view_type == 'DOWNLOAD'){
                filenames += '_다운로드';
              }else if(self.active_view_type == 'RECOMMAND'){
                filenames += '_추천';
              }else if(self.active_view_type == 'RESEARCH'){
                filenames += '_후속연구요청';
              }

              if(self.active_start_date){
                filenames += '_('+self.active_start_date+' ~ '+self.active_end_date+').xlsx';
              }else{
                filenames += '_전체.xlsx';
              }
              self.queryParams.excel_rtype = 'DR';
              var token = sessionStorage.getItem("myToken");
              var param = encodeURI(JSON.stringify(self.queryParams));
              var datas = new FormData();
              datas.append('objs', param);
              self.$http.post('/api/excel/excelUserInfoDownload?access_token=' + token, datas, { responseType: 'blob'})
                .then((result) => {
                  var blob = result.data;
                  if(navigator.appVersion.toString().indexOf('.NET') > 0){ //For IE
                    window.navigator.msSaveOrOpenBlob(blob, filenames);
                  }else if(navigator.userAgent.toLowerCase().indexOf('firefox') >-1){
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    document.body.appendChild(link);//For FireFox <a> tag event
                    //not working
                    link.click();
                  }else{
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    link.click();
                  }
                  swal.close();
                })
            },
          }).then(function() {
            swal.fire(
              '다운로드 완료',
              '',
              'success'
            ).then(function() {

            });
          });
        }
      })
    },

    formatPhoneNumber(phoneNumberString) {
      let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      let match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
      if (match) {
        return '' + match[1] + '' + '-' + match[2] + '-' + match[3]
      }
      return null
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/component/DrInfo/DrInfoList.vue